import {
  ADD_OPTIONS_FOR_POLL,
  ADD_QUESTION_FOR_POLL,
  ADD_DESCRIPTION_FOR_POLL,
  ADD_DATE_FOR_POLL,
  ADD_TAGS_FOR_POLL,
  TOGGLE_IS_ANSWER_FOR_POLL,
  ADD_CATEGORY,
} from "../constants";

// INITIAL STORE FOR POLLS
const initialPollData = {
  question: "",
  description: "",
  options: [
    { option: "", label: 1 },
    { option: "", label: 2 },
  ],
  datePublished: "",
  category: [
    {value: "Games", status: false},
    {value: "Science", status: true},
  ],
  tags: [],
  isAnswer: false,
  active: "",
};

const pollData = (state = initialPollData, action) => {
  switch (action.type) {
    case ADD_QUESTION_FOR_POLL: {
      state.question = action.payload.value;
      return {
        ...state,
      };
    }
    case ADD_DESCRIPTION_FOR_POLL: {
      state.description = action.payload.value;
      return {
        ...state,
      };
    }
    case ADD_DATE_FOR_POLL: {
      state.datePublished = action.payload.value;
      return {
        ...state,
      };
    }
    case ADD_TAGS_FOR_POLL: {
      state.tags = action.payload.value;
      return {
        ...state,
      };
    }
    case TOGGLE_IS_ANSWER_FOR_POLL: {
      state.isAnswer = !state.isAnswer;
      return {
        ...state,
      };
    }
    case ADD_CATEGORY: {
      state.category = action.payload.value;
      return {
        ...state,
      };
    }
    case ADD_OPTIONS_FOR_POLL: {
      console.log(action.payload);
    }
    default:
      return state;
  }
};
export default pollData;
